import { BTLocalStorage } from "types/btStorage";

/**
 * A builder's personal choice of landing view for the Specifications area. Layered on top of the
 * persona default — see {@link getSpecificationViewPreference}.
 */
export type SpecificationViewPreference = "list" | "book";

/**
 * Reads the stored preference. `null` means the user has never used the Book/List toggle, which
 * leaves the persona default in charge — an unset key must stay distinguishable from a deliberate
 * choice of Book View.
 */
export function getSpecificationViewPreference(): SpecificationViewPreference | null {
    return BTLocalStorage.get("bt-string-specificationViewPreference");
}

export function setSpecificationViewPreference(preference: SpecificationViewPreference): void {
    BTLocalStorage.set("bt-string-specificationViewPreference", preference);
}
